import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { matchMedia } from "@limitless/customer/utils/MediaMatch";
import { ClientContext } from "@limitless/common/utils";

const MobileDetectionContext = createContext({});

export const MobileDetectionContextProvider = ({ children }) => {
    const hook = useMobileDetection();

    const context = useMemo(
        () => ({
            ...hook
        }),
        [hook.isMobileDevice]
    );

    return <MobileDetectionContext.Provider value={context}>{children}</MobileDetectionContext.Provider>;
};

export const useMobileDetectionContext = () => {
    return useContext(MobileDetectionContext);
};

MobileDetectionContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

/**
 * Mobile Detection hook only accessed via the context wrapper so isMobileDevice can be made across the whole app
 */
const useMobileDetection = () => {
    const [isMobileDevice, setIsMobileDevice] = React.useState(false);
    const [isFillAvailableSpace, setIsFillAvailableSpace] = React.useState(ClientContext._fillAvailableSpace);

    React.useEffect(() => {
        if (isFillAvailableSpace) {
            setIsMobileDevice(true);
        } else {
            const mq = matchMedia("(max-width: 450px)", onDeviceWidthChange);
            setIsMobileDevice(mq.matches);
        }
    }, [isFillAvailableSpace]);

    const toggleFileSpace = isFillSpace => {
        setIsFillAvailableSpace(isFillSpace);
    };

    const onDeviceWidthChange = mediaQuery => {
        setIsMobileDevice(mediaQuery.matches);
    };

    const offsetStyles = {};
    if (!isMobileDevice) {
        offsetStyles.right = ClientContext._rightOffset;
        offsetStyles.bottom = ClientContext._bottomOffset + 75;
    }

    if (ClientContext._fabButtonStyle === "hidden") {
        offsetStyles.bottom = ClientContext._bottomOffset;
    }

    const getCustomOffsetStyles = (bottom = 0, right) => {
        const customOffsets = {
            bottom: ClientContext._bottomOffset + bottom,
            right: ClientContext._rightOffset
        };

        if (right) {
            let baseRight;
            if (typeof ClientContext._rightOffset === "string") {
                baseRight = Number(ClientContext._rightOffset.replace("px", ""));
            } else {
                baseRight = ClientContext._rightOffset;
            }
            customOffsets.right = baseRight + right;
        }

        return customOffsets;
    };

    return {
        isMobileDevice,
        offsetStyles,
        getCustomOffsetStyles,
        isFillAvailableSpace,
        toggleFileSpace
    };
};
